// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/merge.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_anu_cat_app_enums } from "./enums_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/merge.proto.
 */
export const file_anu_cat_app_merge = /*@__PURE__*/
  fileDesc("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", [file_anu_cat_app_enums, file_buf_validate_validate, file_patch_go]);

/**
 * Describes the message anu.cat_app.CreateMergedSitePreviewRequest.
 * Use `create(CreateMergedSitePreviewRequestSchema)` to create a new message.
 */
export const CreateMergedSitePreviewRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 0);

/**
 * Describes the message anu.cat_app.CreateMergedSitePreviewResponse.
 * Use `create(CreateMergedSitePreviewResponseSchema)` to create a new message.
 */
export const CreateMergedSitePreviewResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 1);

/**
 * Describes the message anu.cat_app.CreateMergedSiteRequest.
 * Use `create(CreateMergedSiteRequestSchema)` to create a new message.
 */
export const CreateMergedSiteRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 2);

/**
 * Describes the message anu.cat_app.CreateMergedSiteResponse.
 * Use `create(CreateMergedSiteResponseSchema)` to create a new message.
 */
export const CreateMergedSiteResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 3);

/**
 * Describes the message anu.cat_app.MergeSitesPreviewRequest.
 * Use `create(MergeSitesPreviewRequestSchema)` to create a new message.
 */
export const MergeSitesPreviewRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 4);

/**
 * Describes the message anu.cat_app.MergeSitesPreviewResponse.
 * Use `create(MergeSitesPreviewResponseSchema)` to create a new message.
 */
export const MergeSitesPreviewResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 5);

/**
 * Describes the message anu.cat_app.MergeSitesRequest.
 * Use `create(MergeSitesRequestSchema)` to create a new message.
 */
export const MergeSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 6);

/**
 * Describes the message anu.cat_app.MergeSitesResponse.
 * Use `create(MergeSitesResponseSchema)` to create a new message.
 */
export const MergeSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 7);

/**
 * Describes the message anu.cat_app.UnmergeSitesPreviewRequest.
 * Use `create(UnmergeSitesPreviewRequestSchema)` to create a new message.
 */
export const UnmergeSitesPreviewRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 8);

/**
 * Describes the message anu.cat_app.UnmergeSitesPreviewResponse.
 * Use `create(UnmergeSitesPreviewResponseSchema)` to create a new message.
 */
export const UnmergeSitesPreviewResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 9);

/**
 * Describes the message anu.cat_app.UnmergeSitesRequest.
 * Use `create(UnmergeSitesRequestSchema)` to create a new message.
 */
export const UnmergeSitesRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 10);

/**
 * Describes the message anu.cat_app.UnmergeSitesResponse.
 * Use `create(UnmergeSitesResponseSchema)` to create a new message.
 */
export const UnmergeSitesResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 11);

/**
 * Describes the message anu.cat_app.ProspectiveParent.
 * Use `create(ProspectiveParentSchema)` to create a new message.
 */
export const ProspectiveParentSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 12);

/**
 * Describes the message anu.cat_app.GeneratedParentData.
 * Use `create(GeneratedParentDataSchema)` to create a new message.
 */
export const GeneratedParentDataSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 13);

/**
 * Describes the message anu.cat_app.TargetChild.
 * Use `create(TargetChildSchema)` to create a new message.
 */
export const TargetChildSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_merge, 14);

